<template>
  <div class="context-menu" :style="{ top: `${position.y}px`, right: `4rem` }" v-show="visible">
    <!-- <button @click="doSomething('字幕を分割する')">字幕を分割する</button> -->

    <!-- <modal style="margin-top: 1rem;" v-if="isItalicized">
      <template v-slot:activator="{ openModal }">
        <button class="btn btn-purple show-modal" @click="romanRegion()">字幕を正体にする</button>
      </template>
    </modal>
    <modal style="margin-top: 1rem;" v-else>
      <template v-slot:activator="{ openModal }">
        <button class="btn btn-purple show-modal" @click="italicRegion()">字幕を斜体(イタリック)にする</button>
      </template>
    </modal> -->

    <!-- <modal style="margin-top: 1rem;">
      <template v-slot:activator="{ openModal }">
        <button class="btn btn-purple show-modal" @click="addRegion()">字幕を追加する</button>
      </template>
    </modal> -->
    <modal style="margin-top: 1rem;">
      <template v-slot:activator="{ openModal }">
        <button class="btn btn-purple show-modal" @click="removeRegion()">字幕を削除する</button>
      </template>
    </modal>
    <modal style="margin-top: 1rem;" v-if="canSplitCaption">
      <template v-slot:activator="{ openModal }">
        <button class="btn btn-purple show-modal" @click="splitRegion()">字幕を分割する</button>
      </template>
    </modal>

    <modal style="margin-top: 1rem;" v-if="hasNextCaption">
      <template v-slot:activator="{ openModal }">
        <button class="btn btn-purple show-modal" @click="concatRegion()">字幕を結合する</button>
      </template>
    </modal>

    <modal style="margin-top: 1rem;" v-if="aimodelId">
      <template v-slot:activator="{ openModal }">
        <button class="btn btn-purple show-modal" @click="translateCaption()">字幕を翻訳する</button>
      </template>
    </modal>


    <!-- <modal style="margin-bottom: 1rem;">
      <template v-slot:activator="{ openModal }">
        <button v-if="caption.length > 1" class="btn btn-purple show-modal"
          @click="openModal(); setModalContent();">字幕を結合する</button>
      </template>
      <template v-slot:modalTitle>
        <div v-if="showEntryModal">字幕を結合する</div>
      </template>
      <template v-slot:modal-content="{ closeModal }">
        <div v-if="showEntryModal">
          <div class="mb-4">
            <label class="form-label">結合先の字幕<span class="mx-2 badge rounded-pill bg-danger">必須</span></label>
            <select class="form-select " v-model="concatRegionId">
              <option v-for="c in canConcatCaptions()" :key="captionId" v-bind:value="c.id">
                {{ c.caption }}
              </option>
            </select>
          </div>
          <div class="modal-btn d-flex justify-content-evenly" v-if="showEntryModal">
            <button class="btn btn-red" @click="closeModal()">戻る</button>
            <button class="btn btn-purple" @click="closeModal(); concatRegion()">結合する </button>
          </div>
        </div>
      </template>
    </modal> -->
  </div>
</template>

<script>
import modal from '@/Pages/Components/modal.vue';
import axios from 'axios';
import Decimal from 'decimal.js';

export default {
  data() {
    return {
      visible: false,
      position: { x: 0, y: 0 },
      handleClickOutside: null,
      regionId: undefined,
      periodFrame: undefined,
      showEntryModal: false,
      concatRegionId: undefined,

      canSplitCaption: undefined,
    };
  },
  components: {
    modal,
  },
  props: ['caption'],
  computed: {
    hasNextCaption() {
      const splitedRegions = this.splitRegions(this.caption, this.regionId);
      if (splitedRegions.length !== 2) {
        return false;
      }
      return splitedRegions[1].length > 0;
    },
    isItalicized() {
      const splitedRegions = this.splitRegions(this.caption, this.regionId);
      if (splitedRegions.length !== 2) {
        return false;
      }
      // console.log('text' + splitedRegions[0][splitedRegions[0].length - 1].trg);
      const italicRegex = /^<i>.*<\/i>$/; // 正規表現パターン
      return italicRegex.test(splitedRegions[0][splitedRegions[0].length - 1].trg);
    },

  },
  methods: {
    setModalContent() {

      this.showEntryModal = true;

      // inputの初期化
      this.entryName = "";
      this.entryTeamId = 0;
      this.entryEmail = "";
      this.entryAuthority = "";
      this.entryComment = "";
      this.canSplitCaption = false;
    },
    async show(regionId, periodFrame, canSplitCaption, e, glossaryId, aimodelId) {
      e.preventDefault();
      this.regionId = regionId;
      this.periodFrame = periodFrame;
      this.position = { x: e.pageX, y: e.pageY };
      this.visible = true;
      this.glossaryId = glossaryId;
      this.aimodelId = aimodelId;

      this.canSplitCaption = canSplitCaption;

      this.handleClickOutside = this.handleOutsideClick.bind(this);
      await new Promise((r) => setTimeout(r, 10)); // TODO: 時間は適宜変更する
      window.addEventListener('click', this.handleClickOutside);
    },
    isHide() {
      return !this.visible;
    },
    handleOutsideClick(event) {
      if (this.visible && !this.$el.contains(event.target)) {
        this.hide();
      }
    },
    hide() {
      this.visible = false;
      window.removeEventListener('click', this.handleClickOutside);
    },
    copy(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    italicRegion(e) {
      let regions = this.splitRegions(this.caption, this.regionId);
      if (regions.length !== 2) {
        this.$emit('update', regions);
      }
      const clickedRegion = regions[0][regions[0].length - 1];
      regions[0][regions[0].length - 1].trg = '<i>' + clickedRegion.trg + '</\i>';
      this.$emit('update', [...regions[0], ...regions[1]]);

      this.hide();
    },
    romanRegion(e) {
      let regions = this.splitRegions(this.caption, this.regionId);
      if (regions.length !== 2) {
        this.$emit('update', regions);
      }
      const clickedRegion = regions[0][regions[0].length - 1];
      regions[0][regions[0].length - 1].trg = clickedRegion.trg.replace(/<\/?i>/g, '');
      this.$emit('update', [...regions[0], ...regions[1]]);

      this.hide();
    },
    addRegion(e) {
      let regions = this.splitRegions(this.caption, this.regionId);
      if (regions.length !== 2) {
        this.$emit('update', regions);
      }
      const clickedRegion = regions[0][regions[0].length - 1];
      const addedRegion = {
        start: clickedRegion.end,
        end: clickedRegion.end,
        src: '',
        result: [],
        trg: clickedRegion.trg,
        id: 'added-' + clickedRegion.id,
      };
      console.log('add region');
      this.$emit('update', [...regions[0], addedRegion, ...regions[1]]);

      this.hide();
    },

    removeRegion(e) {
      let regions = this.splitRegions(this.caption, this.regionId);
      if (regions.length !== 2) {
        this.$emit('update', regions);
      }
      regions[0].pop();

      this.$emit('update', [...regions[0], ...regions[1]]);
      this.hide();
    },

    splitRegion(e) {
      let regions = this.splitRegions(this.caption, this.regionId);
      if (regions.length !== 2) {
        this.$emit('update', regions);
      }

      let editedRegion = regions[0][regions[0].length - 1];
      let addedRegion = this.copy(regions[0][regions[0].length - 1]);

      let middleTime = (editedRegion.start + editedRegion.end) / 2;
      middleTime = Math.floor(middleTime * 1000) / 1000;
      // NOTE: 終了時刻を早くする
      editedRegion.end = middleTime;
      // NOTE: id修正 & 開始時刻を遅くする
      addedRegion.id = 'added-' + addedRegion.id;
      addedRegion.start = middleTime;
      if (editedRegion.end === addedRegion.start) {
        addedRegion.start = Decimal.add(addedRegion.start, this.periodFrame).toNumber();
      }


      this.$emit('update', [...regions[0], addedRegion, ...regions[1]]);
      this.hide();
    },

    concatRegion(e) {
      const splitedRegions = this.splitRegions(this.caption, this.regionId);
      if (splitedRegions.length !== 2) {
        this.$emit('update', splitedRegions);
      }

      const clickedRegionIndex = this.caption.findIndex((c) => c.id === this.regionId);
      const toSplitRegionIndex = clickedRegionIndex + 1;

      let updatedRegionStartTime = Math.min(this.caption[toSplitRegionIndex].start, this.caption[clickedRegionIndex].start);
      let updatedRegionEndTime = Math.max(this.caption[toSplitRegionIndex].end, this.caption[clickedRegionIndex].end);
      updatedRegionStartTime = Math.floor(updatedRegionStartTime * 1000) / 1000;
      updatedRegionEndTime = Math.floor(updatedRegionEndTime * 1000) / 1000;

      const toRemoveRegion = this.caption[toSplitRegionIndex];
      const toUpdateRegions = this.copy(this.caption);
      toUpdateRegions[clickedRegionIndex].start = updatedRegionStartTime;
      toUpdateRegions[clickedRegionIndex].end = updatedRegionEndTime;
      toUpdateRegions[clickedRegionIndex].src += toRemoveRegion.src;
      toUpdateRegions[clickedRegionIndex].trg += toRemoveRegion.trg;
      toUpdateRegions.splice(toSplitRegionIndex, 1);

      this.$emit('update', toUpdateRegions);
      this.hide();
    },

    splitRegions(regions, regionId) {
      const toSplitRegionIndex = regions.findIndex((c) => c.id === this.regionId);

      if (toSplitRegionIndex === -1) {
        return regions;
      }
      const leftRegions = this.caption.slice(0, toSplitRegionIndex + 1);
      const rightRegions = this.caption.slice(toSplitRegionIndex + 1);
      return [leftRegions, rightRegions];
    },

    async translateCaption() {
      const clickedRegionIndex = this.caption.findIndex((c) => c.id === this.regionId);

      // regionがない場合
      if (clickedRegionIndex === -1) {
        return this.caption;
      }

      const sourceText = this.caption[clickedRegionIndex].src;
      const data = new FormData();
      data.append('sourceText', sourceText);
      data.append('glossaryId', this.glossaryId);
      data.append('aimodelId', this.aimodelId);

      // api実行
      await axios.post(route('video_translate.translateCaption'), data)
        .then((res) => {

          this.caption[clickedRegionIndex].trg = res.data.text;
          this.$emit('update', this.caption);
          this.hide();

        })
        .catch((e) => {
          const data = e.response.data;
          if (data === undefined || data.error == undefined) {
            alert('予期せぬエラーが発生しました。再度お試しください。');
          } else {
            alert(Object.values(data.error)[0]);
          }
        });
    }


  },
};
</script>

<style scoped>
.context-menu {
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  z-index: 1000;
  /* 他の要素よりも前面に出るように設定 */
}
</style>
